import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ClockPickerView } from "@mui/x-date-pickers";
import { useFormContext, useWatch } from "react-hook-form";
import { useCallback, useMemo } from "react";
import dayjs from "dayjs";
import { ExpandMore } from "@mui/icons-material";
import { useRecoilState, useRecoilValue } from "recoil";
import { useParams } from "react-router-dom";
import { FormAutocomplete, FormDateTimePicker } from "../../../../components/fields";
import { accordionExpandedState, visibleCarToReplaceAccordion } from "../../recoil";
import { IFormValues } from "../../types";
import { RentalLocationType, RouteParams } from "../../../../types";
import { useBookingSubstitutionQueryObserver } from "../../../../api/services";
import { shouldDisableRentalDate, shouldDisableRentalTime } from "../../../../utils";

const CarToReplace = () => {
    const { t } = useTranslation('booking');
    const { id } = useParams<RouteParams>();
    const { getValues } = useFormContext<IFormValues>();
    const substitutionQuery = useBookingSubstitutionQueryObserver(id);
    const [carToReplaceExpanded, setCarToReplaceExpanded] = useRecoilState(accordionExpandedState('carToReplace'));
    const carToReplaceAccordion = useRecoilValue(visibleCarToReplaceAccordion);
    const dropoffDateRa = useWatch<IFormValues, "originRaData.dropoffDate">({
        name: 'originRaData.dropoffDate'
    });
    const today = useMemo(() => dayjs().hour(0).minute(0), [t]);
    const shouldDisableDate = useCallback((date: dayjs.Dayjs) => {
        return shouldDisableRentalDate(date, getValues('carToReplace.dropoffLocation'), RentalLocationType.Dropoff, [], undefined);
    }, []);
    const shouldDisableTime = useCallback((time: number, clockTime: ClockPickerView) => {
        return shouldDisableRentalTime(time, clockTime, RentalLocationType.Dropoff, getValues('carToReplace.dropoffLocation'), getValues('carToReplace.dropoffDate'));
    }, []);
    return(
        <>
            { carToReplaceAccordion &&
            <Grid item xs={12}>
                <Accordion expanded={carToReplaceExpanded} onChange={(e, expanded) => setCarToReplaceExpanded(expanded)}>
                    <AccordionSummary expandIcon={<ExpandMore/>}
                                      sx={{
                                          '.MuiAccordionSummary-content': {
                                              justifyContent: "space-between",
                                              alignItems: "center"
                                          }
                                      }}
                    >
                        <Typography variant="h5">
                            {t('label.carToReplace_title')}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid item container rowSpacing={1} columnSpacing={3}>
                            <Grid item xs={12} sm={3}>
                                <FormAutocomplete<IFormValues>
                                    name="carToReplace.dropoffLocation"
                                    label={t('label.dropoffLocation')}
                                    options={substitutionQuery.data?.locations ?? []}
                                    loading={substitutionQuery.isLoading}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <FormDateTimePicker<IFormValues>
                                    name="carToReplace.dropoffDate"
                                    label={t('label.dropoffDateTime')}
                                    maxDateTime={dropoffDateRa}
                                    minDateTime={today}
                                    shouldDisableDate={shouldDisableDate}
                                    shouldDisableTime={shouldDisableTime}
                                />
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
                </Grid>
        }
    </>
    );
}

export default  CarToReplace;
